import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import AppShell from "./components/AppShell";
import { AuthProvider } from "./components/AuthProvider";
import Dashboard from "./pages/Dashboard";
import History from "./pages/History";
import Templates from "./pages/Templates";
import Jobs from "./pages/Jobs";
import ErrorPage from "./pages/ErrorPage";
import ErrorBoundary from "./components/ErrorBoundary";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App min-h-screen bg-[#09090B]">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors theme="dark" />
          <ErrorBoundary>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route element={<AppShell />}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/templates" element={<Templates />} />
                  <Route path="/jobs" element={<Jobs />} />
                  <Route path="/error" element={<ErrorPage />} />
                  <Route path="*" element={<ErrorPage />} />
                </Route>
              </Route>
            </Routes>
          </ErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
